import { Module } from 'vuex'
import { RootState } from '@/store/types'
import { state } from './state'
import { mutations } from './mutations'
import { actions } from './actions'
import { getters } from './getters'
import { ScheduleState } from './types'

export const schedule: Module<ScheduleState, RootState> = {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
